import { render, staticRenderFns } from "./formResponsavelEmpresa.vue?vue&type=template&id=53eca73c"
import script from "./formResponsavelEmpresa.vue?vue&type=script&lang=js"
export * from "./formResponsavelEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports